import {
  fetchDynamicConfiguration,
  fetchProductsOfDynamicCategory,
  setGiftsProductsParams,
  changeRecommendationProductsOrder,
  setShowRecommendations,
  fetchProductsOfSelectedCategory,
  fetchProductsByRecommendations,
  fetchAllProductsOfRecommendations,
  resetGiftsProducts,
  fetchGiftsByFilters,
  cleanGiftsProductsParams,
  changeRecommendationProductsPage,
  changeGiftsProductsPageAndFetch,
  setRecommendedCategory
} from 'store/actions/gifts';
import {
  addProduct,
  changeGiftTableProductsPage,
  changeGiftTableProductsSort,
  deleteProduct,
  fetchGiftTableProducts,
  fetchGiftTableInfo
} from 'store/actions/giftTable';

export const mapDispatchToProps = {
  addProduct,
  changeGiftTableProductsPage,
  changeGiftTableProductsSort,
  changeRecommendationProductsOrder,
  deleteProduct,
  fetchDynamicConfiguration,
  fetchProductsOfDynamicCategory,
  fetchGiftTableProducts,
  fetchProductsOfSelectedCategory,
  fetchProductsByRecommendations,
  fetchAllProductsOfRecommendations,
  fetchGiftsByFilters,
  fetchGiftTableInfo,
  resetGiftsProducts,
  setGiftsProductsParams,
  setShowRecommendations,
  cleanGiftsProductsParams,
  changeRecommendationProductsPage,
  changeGiftsProductsPageAndFetch,
  setRecommendedCategory
};

export const mapStateToProps = ({ giftTable, gifts }) => ({
  products: gifts.listOfGifts.results.list,
  listOfGifts: gifts.listOfGifts,
  giftsParams: gifts.listOfGifts.params,
  tableInfo: giftTable.giftTableInfo.data,
  categories: gifts.productsByRecommendations.data.categories,
  selectedCategory: gifts.selectedCategory,
  filters: gifts.filters,
  showRecommendations: gifts.showRecommendations,
  dynamicRecommendations: gifts.dynamicRecommendation.data.configurations,
  giftTableProducts: giftTable.giftTableProducts,
  withRecommendations: gifts.withRecommendations,
  emptyRecommendations: gifts.dynamicRecommendation.empty,
  categoryLoadError: gifts.productsByRecommendations.error
});
